import { Logger } from './class/Logger';

export const logger = new Logger('nēxt');

export enum LoggerType {
    DISASSOCIATE_USER = 'DISASSOCIATE_USER',
    DELETE_USER = 'DELETE_USER',
}
